// Hrefs with an explicit scheme (https:, mailto:, tel:, ...) or protocol-relative
// hrefs must leave the app, so they escape the docs base-route prefix; anchors and
// './'-relative links resolve in place; everything else is a doc path under baseRoute.
const hasUriScheme = (href) => /^[a-z][a-z0-9+.-]*:/i.test(href) || href.startsWith('//')

const transformDocLink = (href, baseRoute) => {
  if (href.startsWith('#') || href.startsWith('.') || hasUriScheme(href)) {
    return href
  }
  return `${baseRoute}/${href}`
}

export default transformDocLink
